module.exports = __webpack_public_path__ + "93aa1b7a7604ec0ba24dd6d137caa2d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/news/homeworld.jpg
// module id = 284
// module chunks = 0